import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { commerceAPI } from '@/utils/api';
import { Card } from '@/components/ui/card';
import { StatTile, fmtCve } from './shared';

export const SalesTab = () => {
  const { t } = useTranslation();
  const [s, setS] = useState(null);
  useEffect(() => { commerceAPI.stats().then((r) => setS(r.data)).catch(() => toast.error(t('adminCommerce.loadError'))); }, [t]);
  if (!s) return <p className="text-sm text-slate-500">…</p>;
  const tot = s.totals;
  return (
    <div data-testid="sales-tab">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-8">
        <StatTile label={t('adminCommerce.sales.revenue30')} value={fmtCve(tot.revenue_30d_cve)} sub={t('adminCommerce.sales.purchasesCount', { count: tot.purchases_30d })} testId="sales-revenue-30d" />
        <StatTile label={t('adminCommerce.sales.revenueTotal')} value={fmtCve(tot.revenue_cve)} sub={t('adminCommerce.sales.purchasesCount', { count: tot.purchases })} testId="sales-revenue-total" />
        <StatTile label={t('adminCommerce.sales.discounts')} value={fmtCve(tot.discount_cve)} sub={t('adminCommerce.sales.bonusGiven', { count: tot.bonus_credits })} testId="sales-discounts" />
        <StatTile label={t('adminCommerce.sales.payingEmployers')} value={tot.paying_employers} sub={t('adminCommerce.sales.grantedCredits', { count: tot.granted_credits })} testId="sales-paying-employers" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="p-5" data-testid="sales-by-plan">
          <h3 className="font-semibold text-slate-900 mb-3">{t('adminCommerce.sales.byPlan')}</h3>
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b"><th className="py-2">{t('adminCommerce.sales.plan')}</th><th className="text-right">30d</th><th className="text-right">{t('adminCommerce.sales.total')}</th><th className="text-right">{t('adminCommerce.sales.revenue')}</th></tr></thead>
            <tbody>
              {s.by_plan.map((b) => (
                <tr key={b.plan_type} className="border-b last:border-0">
                  <td className="py-2"><div className="font-medium">{b.plan_name || b.plan_type}</div><code className="text-[11px] text-slate-500">{b.plan_type}</code></td>
                  <td className="text-right">{b.count_30d}</td>
                  <td className="text-right">{b.count}</td>
                  <td className="text-right font-semibold">{fmtCve(b.revenue_cve)}</td>
                </tr>
              ))}
              {!s.by_plan.length && <tr><td colSpan={4} className="py-6 text-center text-slate-500">{t('adminCommerce.noData')}</td></tr>}
            </tbody>
          </table>
        </Card>

        <Card className="p-5" data-testid="sales-offer-usage">
          <h3 className="font-semibold text-slate-900 mb-3">{t('adminCommerce.sales.offerUsage')}</h3>
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b"><th className="py-2">{t('adminCommerce.sales.offer')}</th><th>{t('adminCommerce.sales.source')}</th><th className="text-right">{t('adminCommerce.sales.uses')}</th><th className="text-right">{t('adminCommerce.sales.saving')}</th></tr></thead>
            <tbody>
              {s.offer_usage.map((o) => (
                <tr key={o.id} className="border-b last:border-0">
                  <td className="py-2 font-medium">{o.name}</td>
                  <td><span className="text-[11px] uppercase font-bold text-slate-500">{t(`checkout.offerSource.${o.source}`)}</span></td>
                  <td className="text-right">{o.uses}</td>
                  <td className="text-right">{o.saving_cve ? fmtCve(o.saving_cve) : `+${o.bonus_credits} ${t('adminCommerce.bonusCreditsShort')}`}</td>
                </tr>
              ))}
              {!s.offer_usage.length && <tr><td colSpan={4} className="py-6 text-center text-slate-500">{t('adminCommerce.sales.noOffers')}</td></tr>}
            </tbody>
          </table>
        </Card>
      </div>
    </div>
  );
};
